import AuthenticateFrame from './AuthenticateFrame';

export default AuthenticateFrame;